// src/components/Contact.js
import React from 'react';
import styled from 'styled-components';
import { FaXTwitter } from 'react-icons/fa6';
import { AiOutlineMail } from "react-icons/ai";

const PageContainer = styled.div`
  padding: 20px;
  text-align: left;
  max-width: 800px;
  margin: 0 auto;
  color: #5c5c5c;
  font-family: 'aria-label', sans-serif;
`;

const SocialLink = styled.a`
  display: flex;
  align-items: center;
  color: #333;
  text-decoration: none;
  font-size: 18px;

  &:hover {
    text-decoration: underline;
  }
`;

const EmailLink = styled.a`
  color: #4b6353; /* This controls the color of the email link */
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const Icon = styled(FaXTwitter)`
  margin-right: 8px;
`;

const Email = styled(AiOutlineMail)`
  margin-right: 8px;
`;

const Contact = () => (
  <PageContainer>
    <h1>Contact Us</h1>
    <p>
      We'd love to hear from you! If you have any questions, feedback, or suggestions, please don't
      hesitate to reach out to us. Your thoughts and ideas are valuable in helping us improve and provide
      you with the best experience possible.
    </p>
    <p>
      Whether you're a new user with questions about getting started, a seasoned user with advanced queries, 
      or someone with suggestions on how we can make our platform even better, we're here for you.
    </p>
    <p>
      You can contact us using the following methods:
    </p>
    <p>
      <Email /> <EmailLink  href="mailto:thelalabmy@gmail.com" target="_blank" rel="noopener noreferrer">thelalabmy@gmail.com</EmailLink >
    </p>
    <p>
      Stay connected with us on social media for the latest updates, feature announcements, and more:
    </p>
    <p>
      <SocialLink href="https://x.com/theLAlabMY" target="_blank" rel="noopener noreferrer">
        <Icon /> Twitter
      </SocialLink>
    </p>
    <p>
      We strive to respond to all inquiries within 24-48 hours. Thank you for reaching out to us!
    </p>
  </PageContainer>
);

export default Contact;
